// @ts-nocheck
import React, { Suspense } from 'react';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayjsUtils from '@date-io/dayjs';
import { AlertProvider, DialogProvider } from '../../../common/providers';
import { FullScreenLoading } from '../../../common/components';
import AppThemeProvider from '../providers/AppThemeProvider';
import AppRoutes from './partials/AppRoutes';

function App() {
  return (
    <AppThemeProvider>
      <CssBaseline />
      <Suspense fallback={<FullScreenLoading />}>
        <MuiPickersUtilsProvider utils={DayjsUtils}>
          <DialogProvider>
            <AlertProvider>
              <AppRoutes />
            </AlertProvider>
          </DialogProvider>
        </MuiPickersUtilsProvider>
      </Suspense>
    </AppThemeProvider>
  );
}

export default App;
